import React, { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import {
  SpacePreview,
  PreviewableSpace,
} from '../../../components/SpacePreview';
import { LoadingIndicator } from '../../../components/LoadingIndicator';

/*
 * Types.
 */

interface SpacesListProps {
  spaces: PreviewableSpace[];
  loading?: boolean;
}

/*
 * Components.
 */

export const SpacesList: FC<SpacesListProps> = ({
  spaces,
  loading = false,
}: SpacesListProps) => (
  <Stack direction="column" gap="24px">
    {!spaces.length && !loading && (
      <Stack
        direction="column"
        gap="18px"
        alignItems="center"
        justifyContent="center"
        sx={{ paddingTop: '20vh' }}
      >
        <img alt="" src="/bus.png" height="84px" />
        <Typography variant="body2" sx={{ fontSize: '20px' }}>
          No spaces available. Expand your search or remove your filters
        </Typography>
      </Stack>
    )}
    {spaces.length > 0 && (
      <Box
        sx={{
          display: 'grid',

          gap: '24px',
          gridTemplateColumns: {
            xs: '1fr',
            sm: '1fr',
            md: '1fr',
            lg: 'repeat(2, 1fr)',
            xl: 'repeat(3, 1fr)',
          },
        }}
      >
        {spaces.map((space) => (
          <SpacePreview key={space.slug} space={space} />
        ))}
      </Box>
    )}
    {loading && <LoadingIndicator />}
  </Stack>
);
